'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _percentage = require('./utils/percentage');

var _percentage2 = _interopRequireDefault(_percentage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 */
function makeDefaultText(_ref) {
	var min = _ref.min;
	var max = _ref.max;
	var value = _ref.value;

	var progress = Math.round((0, _percentage2.default)(value, max, min));
	return progress + '%';
}

/**
 *
 */
function makeDefaultStyle(_ref2) {
	var min = _ref2.min;
	var max = _ref2.max;
	var value = _ref2.value;
	var orientation = _ref2.orientation;

	var dimension = (0, _percentage2.default)(value, max, min);
	var property = orientation === 'horizontal' ? 'width' : 'height';

	return _defineProperty({}, property, dimension + '%');
}

/**
 *
 */
var ProgressBar = function ProgressBar(props) {
	var min = props.min;
	var max = props.max;
	var value = props.value;
	var orientation = props.orientation;
	var makeText = props.makeText;
	var makeStyle = props.makeStyle;


	var text = makeText(props);
	var style = makeStyle(props);

	var className = (0, _classnames2.default)(['rea11y-ProgressBar', 'rea11y-ProgressBar--' + orientation]);

	return _react2.default.createElement(
		'div',
		{
			className: className,
			role: 'progressbar',
			'aria-valuemin': min,
			'aria-valuemax': max,
			'aria-valuenow': value,
			'aria-valuetext': text
		},
		_react2.default.createElement(
			'div',
			{ className: 'rea11y-ProgressBar-track' },
			_react2.default.createElement('div', { className: 'rea11y-ProgressBar-value', style: style })
		),
		_react2.default.createElement(
			'div',
			{ className: 'rea11y-ProgressBar-text' },
			text
		)
	);
};

ProgressBar.propTypes = {
	orientation: _react.PropTypes.string,
	min: _react.PropTypes.number,
	max: _react.PropTypes.number,
	value: _react.PropTypes.number,
	makeText: _react.PropTypes.func,
	makeStyle: _react.PropTypes.func
};

ProgressBar.defaultProps = {
	orientation: 'horizontal',
	min: 0,
	max: 100,
	value: 0,
	makeText: makeDefaultText,
	makeStyle: makeDefaultStyle
};

exports.default = (0, _recompose.pure)(ProgressBar);